// Triggers Main Tab (2699758070)
/*
Ashraf 09/22/2022  2699758070 event tactics sidebar changes
Sohel  10/15/2022  2699758070 Added Code Comments
Ashraf  10/28/2022  2699758070 moved main tabs to header
Prakash 12/26/2022 2699758070 Removed unused styles.
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import EventTacticSubTabs from './SubTabs.js';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function EventTacticTabs({value}) {
  const classes = useStyles();

  return (
    <div className={classes.subContent}>
      {value === 0 && (
        <EventTacticSubTabs />
      )}
    </div>
  );
}
